<template>
  <div
      class="h-screen flex w-full bg-primary vx-row no-gutter items-center justify-center"
      id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div
              class="vx-row no-gutter justify-center items-center p-10"
              v-if="error.length == 0 && !newPass"
          >
            <div class="w-full justify-center">
              <div class="vx-row no-gutter justify-center items-center">
                <img
                    src="../../../assets/images/logo/logo-grupo_2024.png"
                    alt="login"
                    width="100"
                    class="mx-auto"
                />
              </div>
            </div>
            <div class="vx-col w-full mt-3 mb-2 w-full text-center">
              <h4>RECUPERAÇÃO DE SENHA</h4>
            </div>
            <!-- email -->
            <div class="vx-row w-full ml-4 mb-2">
              <div class="vx-row sm:w-full ml-4 md:w-full mb-2">
                <div class="vx-col w-full">
                  <vs-input
                      class="w-full"
                      icon-pack="feather"
                      icon="icon-mail"
                      icon-no-border
                      :danger="validator.email"
                      label-placeholder="email"
                      v-model="email"
                  />
                </div>
              </div>
            </div>
            <!-- Submit -->
            <div class="vx-row w-full mt-2">
              <div class="vx-col w-full float-right">
                <vs-button
                    class="mb-2 float-right"
                    color="primary"
                    @click="recuperar()"
                    style="color: black"
                >Confirmar
                </vs-button
                >
              </div>
            </div>
          </div>
          <div
              class="vx-row no-gutter justify-center items-center p-10"
              v-if="error.length == 0 && newPass"
          >
            <div class="w-full justify-center">
              <div class="vx-row no-gutter justify-center items-center">
                <img
                    src="../../../assets/images/logo/logo-grupo_2024.png"
                    alt="login"
                    width="100"
                    class="mx-auto"
                />
              </div>
            </div>
            <div class="vx-col w-full mt-3 mb-2 w-full text-center">
              <h4>DIGITE SUA NOVA SENHA</h4>
            </div>
            <!-- email -->
            <div class="vx-row w-full ml-4 mb-2">
              <div class="vx-row sm:w-full ml-4 md:w-full mb-2">
                <div class="vx-col w-full">
                  <vs-input
                      class="w-full"
                      icon-pack="feather"
                      icon="icon-lock"
                      icon-no-border
                      :danger="validator.senha"
                      label-placeholder="Senha"
                      v-model="senha"
                      type="password"
                  />
                </div>
              </div>
            </div>
            <div class="vx-row w-full ml-4 mb-2">
              <div class="vx-row sm:w-full ml-4 md:w-full mb-2">
                <div class="vx-col w-full">
                  <vs-input
                      class="w-full"
                      type="password"
                      icon-pack="feather"
                      icon="icon-lock"
                      icon-no-border
                      :danger="validator.senhaRepete"
                      label-placeholder="Repita a senha"
                      v-model="senhaRepete"
                  />
                </div>
              </div>
            </div>
            <!-- Submit -->
            <div class="vx-row w-full mt-2">
              <div class="vx-col w-full float-right">
                <vs-button
                    style="color: black"
                    class="mb-2 float-right"
                    @click="updatePass()"
                >Atualizar senha
                </vs-button
                >
              </div>
            </div>
          </div>
          <div
              class="vx-row no-gutter text-center items-center p-10"
              v-if="error.length > 0"
          >
            <h2>{{ error }}</h2>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      email: "",
      token: "",
      error: "",
      senha: "",
      senhaRepete: "",
      newPass: false,
      validator: {
        email: false,
        senha: false,
        senhaRepete: false
      },
      app_host: (process.env.VUE_APP_HOST && process.env.VUE_APP_HOST !== '/' && !process.env.VUE_APP_HOST.includes('localhost'))
        ? process.env.VUE_APP_HOST
        : (typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin : ''),
    };
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker
  },
  methods: {
    async recuperar() {
      await this.$vs.loading();
      try {
        const originHost = (typeof window !== 'undefined' && window.location && window.location.origin)
          ? window.location.origin
          : this.app_host;
        await this.$http.post("resetPassword",
            {
              email: this.email,
              app_host: originHost
            });
        this.$vs.notify({
          title: "Sucesso",
          text:
              "Você receberá um email com as instruções para recuperar sua senha.",
          color: "success"
        });
      } catch (err) {
        console.log(err.response ? err.response.status : err);
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close();
      }
    },
    getUser() {
      try {
        const href = window.location.href;
        let email = "";
        const emailMatch = href.match(/[?&]email=([^&/#]+)/) || href.match(/email=([^&/#]+)/);
        if (emailMatch && emailMatch[1]) {
          email = decodeURIComponent(emailMatch[1]);
        } else {
          const emailIndex = href.indexOf("email=");
          const tokenIndex = href.indexOf("&token");
          if (emailIndex !== -1 && tokenIndex !== -1) {
            email = decodeURIComponent(href.substring(emailIndex + 6, tokenIndex));
          }
        }
        this.email = email !== "http:" ? email : "";

        let tokenValue = "";
        const tokenMatch = href.match(/[?&]token=([^&#]+)/) || href.match(/token=([^&#]+)/);
        if (tokenMatch && tokenMatch[1]) {
          tokenValue = decodeURIComponent(tokenMatch[1]);
        } else if (href.includes("token=")) {
          tokenValue = decodeURIComponent(href.split("token=").pop().split(/[&#]/)[0]);
        }
        if (tokenValue.endsWith("/")) {
          tokenValue = tokenValue.slice(0, -1);
        }
        this.token = { token: tokenValue };

        this.link = href.includes("/redefinir") ? "redefinir" : href.split("/").pop();
      } catch (e) {
        console.error("Erro ao obter parâmetros de recuperação:", e);
      }
    },
    async getInitialInfo() {
      if (this.link !== "redefinir" && this.token && this.token.token) {
        this.$vs.loading();
        try {
          const res = await this.$http.post("validate", this.token);
          if (res && res.hasOwnProperty("id")) {
            this.newPass = true;
          } else {
            this.$vs.notify(this.$notify.RecoverPassword.errorToken);
          }
        } catch (err) {
          console.error("Erro ao validar token:", err);
          this.$vs.notify(this.$notify.RecoverPassword.errorToken);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    async valid() {
      if (this.senha.length == 0) {
        await this.$vs.notify({
          time: 2000,
          title: "",
          text: "As senhas nao podem ser vazias",
          color: "danger"
        });
      } else if (this.senha != this.senhaRepete) {
        await this.$vs.notify({
          time: 2000,
          title: "",
          text: "As senhas não coincidem",
          color: "danger"
        });
      } else {
        return true;
      }
    },
    async updatePass() {
      let validation = await this.valid();
      if (validation) {
        this.$vs.loading();
        try {
          const res = await this.$http.post("colaboradorNovaSenha", {
            email: this.email,
            password: this.senha
          });

          if (res.hasOwnProperty("id")) {
            await this.$vs.notify({
              time: 2000,
              title: "",
              text: "Senha atualizada com successo!",
              color: "success"
            })
            window.location = await HOSTS.HOST
            setTimeout(() => {
            }, 1000)
          } else {
            this.$vs.notify(this.$notify.Error);
          }
        } catch (err) {

        } finally {
          this.$vs.loading.close();
        }
      }
    }
  },
  async mounted() {
    await this.getUser();
    await this.getInitialInfo();
  }
};
</script>

<style lang="scss"></style>
